import { useField } from "formik";
import {
  DisplayFormErrors,
  FusionMelcoModelsDefaultAppSetting,
  SelectField,
  useConfirm,
  VerticalForm,
} from "melco-shared-logic";
import { FormItem, Space, Switch } from "melco-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type DisplayBasicSettingsFormProps = {
  defaultSettings: FusionMelcoModelsDefaultAppSetting;
  settings: any;
};

export const DisplayBasicSettingsForm: React.FC<
  DisplayBasicSettingsFormProps
> = ({ defaultSettings, settings }) => {
  const { t } = useTranslation();

  const [enableProductionLinks, setEnableProductionLinks] = useState<boolean>(
    settings.enable_production_links
  );
  const [field, , { setValue }] = useField("enable_production_links");

  const confirmEnableProductionLinks = useConfirm(
    async () => {
      setValue(!field.value);
      setEnableProductionLinks(!field.value);
    },
    {
      translationPrefix: "settings.basic.enable_production_links",
      content: (
        <Space direction="vertical" size="small">
          {
            t("settings.basic.enable_production_links.confirmation.message")
          }
        </Space>
      ),
    }
  );

  return (
    <VerticalForm>
      <DisplayFormErrors />

      <SelectField
        name="measurement_unit"
        label={t("settings.basic.form.label.measurement_unit")}
        options={(defaultSettings.measurements ?? []).map((measurement) => {
          return {
            label: t([
              `settings.basic.form.values.measurement_unit.${measurement.key}` as any,
              measurement.display_text!,
            ]),
            value: measurement.key!,
          };
        })}
        showSearch
        optionFilterProp="label"
      />

      <SelectField
        name="default_embroidery_production_file_format"
        label={t(
          "settings.basic.form.label.default_embroidery_production_file_format"
        )}
        options={(defaultSettings.emb_formats ?? []).map((embFormat) => {
          return {
            label: t([
              `settings.basic.form.values.default_embroidery_production_file_format.${embFormat.key}` as any,
              embFormat.display_text!,
            ]),
            value: embFormat.key!,
          };
        })}
        showSearch
        optionFilterProp="label"
      />
      {process.env.REACT_APP_PRODUCT_VARIANT! === "fusion" ? (
        <>
          <FormItem label={t("settings.basic.form.label.enable_production_links")} layout="vertical">
            <Switch
              data-cy-id={`enable_production_links`}
              value={enableProductionLinks}
              onChange={() => {
                if (!enableProductionLinks)
                  confirmEnableProductionLinks();
                else {
                  setValue(!field.value)
                  setEnableProductionLinks(!field.value)
                }
              }}
            />
          </FormItem>
        </>
      ) : (
        <></>
      )}
    </VerticalForm>
  );
};
